const TipsCard = () => {
  const tips = [
    'Speak clearly and at a moderate pace',
    'Position microphone 6-12 inches away',
    'Minimize background noise when possible',
    'Pause briefly between different topics',
    'Review and edit transcript after recording'
  ];

  return (
    <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-6 border border-teal-200">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-blue-500 rounded-lg flex items-center justify-center">
          <i className="ri-lightbulb-fill text-white text-sm"></i>
        </div>
        <h3 className="text-lg font-semibold text-slate-900">Recording Tips</h3>
      </div>

      <ul className="space-y-2">
        {tips.map((tip, index) => (
          <li key={index} className="flex items-start gap-2 text-sm text-slate-700">
            <i className="ri-checkbox-circle-fill text-teal-500 flex-shrink-0 mt-0.5"></i>
            <span>{tip}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TipsCard;